// extracted by mini-css-extract-plugin
export var borderRadius = "_a9-4";
export var large = "_a9-3";
export var logoContainer = "_a9-0";
export var nameLogo = "_a9-2";
export var small = "_a9-1";